module.exports = __webpack_public_path__ + "img/mars-and-venus.022fd3c5.svg";